angular.module('bmsApp.settings')
	.controller('OnlineDiscountCtrl', OnlineDiscountCtrl);

OnlineDiscountCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'notify',
	'OnlineDiscountSvc',
	'LicenseOptionsSvc',
];

function OnlineDiscountCtrl($scope, $state, $q, notify, OnlineDiscountSvc, LicenseOptionsSvc) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		processing: false,
		handlers: handlers,
		options: {},
	});

	this.$onInit = () => {
		loadData();
	};

	function loadData() {
		let promises = {
			licenses: LicenseOptionsSvc.license().then((response) => {
				self.options.licenses = response.data.options;
			}),
			discounts: OnlineDiscountSvc.index().then((response) => {
				self.onlineDiscounts = response.data.collection;
			}),
		};
		$q.all(promises).then((response) => {
			self.loading = false;
		});
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.addNewClick = () => {
		self.onlineDiscounts.push({
			editing: true,
		});
	};

	handlers.remove = (discount, $index) => {
		if(discount.id){
			discount.deleted = true;
		} else {
			self.onlineDiscounts.splice($index, 1);
		}
	};

	handlers.disableOtherEmailRedemptionCodes = (discount, index) => {
		var otherDiscounts = angular.forEach(self.onlineDiscounts, (onlineDiscount, key) => {
			if(onlineDiscount.license.id == discount.license.id && index != key){
				onlineDiscount.email_redemption_code = false;
			}
		});
	};

	handlers.recheckEmailRedemptionCodes = (discount, index) => {
		if(discount.email_redemption_code == true){
			var otherDiscounts = angular.forEach(self.onlineDiscounts, (onlineDiscount, key) => {
				if(onlineDiscount.license.id == discount.license.id && index != key){
					onlineDiscount.email_redemption_code = false;
				}
			});
		}
	};

	handlers.submitClick = function () {
		OnlineDiscountSvc.save(self.onlineDiscounts).then((response) => {
			notify({
				message: 'Successfully saved',
			});
			loadData();
		}, (errors) => {
			self.errors = errors;
		});
	};
}
